"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("../common/logger");
var internal_1 = require("../types/internal");
var PlaceHolder = (function () {
    function PlaceHolder() {
        var _this = this;
        this.split = function (text) {
            var wrapped = _this.splitToStringWrappers(text);
            return _this.convertToStringParts(wrapped);
        };
        this.splitToStringWrappers = function (text) {
            // add marker to '{' and '}' characters: "abc {x} def {y}" => "abc {_x_} def {_y_}"
            var replacedPlaceholders = text.split('{').join('{' + PlaceHolder.MARKER).split('}').join(PlaceHolder.MARKER + '}');
            // split by '{' and '}' chars: "... def {_y_}" => [... " def ", "_y_", ""]
            var splitPieces = [].concat.apply([], replacedPlaceholders.split('{').map(function (subset) { return subset.split('}'); }));
            // remove empty pieces: [... "_y_", ""] => [... "_y_"]
            var filtered = splitPieces.filter(function (part) { return !!part; });
            // wrap with StringWrapper for more comfortable string handling
            return filtered.map(function (part) { return new internal_1.StringWrapper(part); });
        };
        this.toPlaceholder = function (name) {
            return '{' + name + '}';
        };
        this.convertToStringParts = function (input, result, until) {
            var currentIndex = 0;
            //@todo move to StringWrapper
            var isPlaceholder = function (text) {
                return text.startsWith(PlaceHolder.MARKER) && text.endsWith(PlaceHolder.MARKER);
            };
            //@todo move to StringWrapper
            var toName = function (placeholder) {
                return placeholder.withoutPostfix(PlaceHolder.MARKER).withoutPrefix(PlaceHolder.MARKER).toString();
            };
            var walkUntil = function (input, result, until) {
                if (typeof result === 'undefined') {
                    return walkUntil(input, []);
                }
                if (typeof until === 'undefined') {
                    return walkUntil(input, result, function () { return input.length <= currentIndex; });
                }
                if (until(currentIndex)) {
                    return result;
                }
                var element = input[currentIndex];
                if (element.endsWith(PlaceHolder.TAG_END_POSTFIX)) {
                    var tagName = element.withoutPrefix(PlaceHolder.MARKER).withoutPostfix(PlaceHolder.TAG_END_POSTFIX);
                    logger_1.logger.warning('Unexpected END tag: ' + tagName.toString());
                }
                if (element.endsWith(PlaceHolder.TAG_START_POSTFIX)) {
                    currentIndex++;
                    result.push(new internal_1.StringPart({
                        isPlaceholder: false,
                        isTag: true,
                        value: element.withoutPostfix(PlaceHolder.TAG_START_POSTFIX).withoutPrefix(PlaceHolder.MARKER).toString(),
                        content: walkUntil(input, [], function (index) {
                            return (until(index)) || input[index].endsWith(PlaceHolder.TAG_END_POSTFIX);
                        }),
                    }));
                }
                else {
                    var elementIsPlaceholder = isPlaceholder(element);
                    result.push(new internal_1.StringPart({
                        isPlaceholder: elementIsPlaceholder,
                        isTag: false,
                        value: elementIsPlaceholder ? toName(element) : element.toString(),
                        content: null
                    }));
                }
                currentIndex++;
                return walkUntil(input, result, until);
            };
            return walkUntil(input, result, until);
        };
    }
    return PlaceHolder;
}());
PlaceHolder.MARKER = '_PLACEHOLDER_';
PlaceHolder.TAG_END_POSTFIX = '_END' + PlaceHolder.MARKER;
PlaceHolder.TAG_START_POSTFIX = '_START' + PlaceHolder.MARKER;
exports.PlaceHolder = PlaceHolder;
exports.placeHolder = new PlaceHolder();
